import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import {
  getAdminAccountsData,
  searchAccounts,
  fetchAccountDetails,
} from '../../../actions/adminActions';

import AccountsSearch from './AccountsSearch';
import AccountListTable from './AccountListTable';

class AccountsLanding extends Component {
  static propTypes = {
    adminAccountsSearchData: PropTypes.instanceOf(Object),
    adminAccountSearchQuery: PropTypes.instanceOf(Object),
    searchAccounts: PropTypes.func,
    fetchAccountDetails: PropTypes.func,
    isAdminAccountSearching: PropTypes.bool,
  };

  static defaultProps = {
    isAdminAccountSearching: false,
    adminAccountsSearchData: {},
    adminAccountSearchQuery: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      accounts: [],
      hasMorePages: true,
      searchTerm: {},
      pageStart: 1,
      sortOrder: 'asc',
    };
  }

  UNSAFE_componentWillMount() {
    const { adminAccountsSearchData, adminAccountSearchQuery } = this.props;
    this.updateSearchQuery(adminAccountsSearchData, adminAccountSearchQuery);
    const sq = {
      pageNo: 1,
    };
    this.props.searchAccounts(sq);
  }

  UNSAFE_componentWillReceiveProps({
    adminAccountsSearchData,
    adminAccountSearchQuery,
  }) {
    this.updateSearchQuery(adminAccountsSearchData, adminAccountSearchQuery);
  }

  updateSearchQuery = (adminAccountsSearchData, adminAccountSearchQuery) => {
    if (!_.isEqual(adminAccountsSearchData.data, this.state.accounts)) {
      if (adminAccountsSearchData.data)
        adminAccountsSearchData.data.map(item => {
          item.accountName =
            item.accountType === 'TPP'
              ? item.accountName + ' ' + '(Third Party)'
              : item.accountName;
        });
      this.setState({
        accounts: adminAccountsSearchData.data,
        hasMorePages: adminAccountsSearchData.hasMorePages,
        pageStart: 1,
      });
    }
    if (!_.isEmpty(adminAccountSearchQuery)) {
      const queryObj = _.cloneDeep(adminAccountSearchQuery);
      const updatedSearchTerm = { ...this.state.searchTerm, ...queryObj };
      this.setState({ searchTerm: updatedSearchTerm });
    }
  };

  loadItems = page => {
    const { searchTerm } = this.state;
    const sq = _.cloneDeep(searchTerm);
    sq.pageNo = page.toString();
    getAdminAccountsData(sq).then(response => {
      const moreAccounts = _.cloneDeep(this.state.accounts);
      response.data.map(item => {
        item.accountName =
          item.accountType === 'TPP'
            ? item.accountName + ' ' + '(Third Party)'
            : item.accountName;
        moreAccounts.push(item);
        return null;
      });
      this.setState({
        hasMorePages: response.hasMorePages,
        accounts: moreAccounts,
      });
    });
  };

  onSort = (sortBy, sortOrder) => {
    const { searchTerm } = this.state;
    const sq = _.cloneDeep(searchTerm);
    sq.sortBy = sortBy;
    sq.sortOrder = sortOrder;
    sq.pageNo = '1';
    this.setState({ sortOrder, searchTerm: sq, pageStart: 1 }, () => {
      this.props.searchAccounts(this.state.searchTerm);
    });
  };

  setSortKeyOnClear = () => {
    this.setState({ sortOrder: 'asc' });
  };

  render() {
    const { accounts, pageStart, hasMorePages, sortOrder } = this.state;
    const { isAdminAccountSearching } = this.props;
    return (
      <div className="accounts-search-box">
        <AccountsSearch setSortKeyOnClear={this.setSortKeyOnClear} />
        {_.isEmpty(accounts) && isAdminAccountSearching && (
          <div className="no-result-found">No result found.</div>
        )}
        {!_.isEmpty(accounts) && (
          <AccountListTable
            accounts={accounts}
            pageStart={pageStart}
            loadMore={this.loadItems}
            hasMore={hasMorePages}
            onSort={this.onSort}
            sortOrder={sortOrder}
            showAccountDetails={this.props.fetchAccountDetails}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ admin }) => {
  return {
    adminAccountsSearchData: admin.adminAccountsSearchData,
    adminAccountSearchQuery: admin.adminAccountSearchQuery,
    isAdminAccountSearching: admin.isAdminAccountSearching,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    searchAccounts: bindActionCreators(searchAccounts, dispatch),
    fetchAccountDetails: bindActionCreators(fetchAccountDetails, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountsLanding);
